import { jsx as _jsx } from "react/jsx-runtime";
import { TableCell } from '@/core/ui';
import { forwardRef } from 'react';
import { TableCellRowSpanStyled } from './TableCellRowSpan.styled';
/**
 * Creates rowspanned cell and places a text to the top of the cell.
 *
 * @param {boolean} isLast
 * @public
 */
const TableCellRowSpan = forwardRef(({ rowSpan, isLast, children, ...props }, ref) => {
    if (rowSpan === 1)
        return (_jsx(TableCell, { ...props, ref: ref, children: children }));
    return (_jsx(TableCellRowSpanStyled, { ...props, ref: ref, rowSpan: rowSpan, isLast: isLast, children: children }));
});
export { TableCellRowSpan };
